export const ErrorIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z"
                stroke="#F8200C"
                strokeWidth="0.875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7 8.16732V4.08398" stroke="#F8200C" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 9.91602H7.00583" stroke="#F8200C" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
